export class LottoProduzione {
    idLottoProduzione: number;
    numeroLottoProduzione: string;
    tipoProdotto: string;
    statoLotto: number;
    codErroreProduzione: number;
    dxErroreProduzione: string;
    snCarte: string[];
    numeroProdotti: number;
    idLottoSpedizione: number;
    numeroLottoSpedizione: string;
    recVer: number;

    constructor() {
        this.idLottoProduzione = null;
        this.numeroLottoProduzione = null;
        this.tipoProdotto = null;
        this.statoLotto = null;
        this.codErroreProduzione = null;
        this.dxErroreProduzione = null;
        this.snCarte = [];
        this.numeroProdotti = null;
        this.idLottoSpedizione = null;
        this.numeroLottoSpedizione = null;
        this.recVer = 0;
    }
}

export enum LottoProduzione_Stato {
    Ordinato = 1,
    DaProdurre = 2,
    Caricato = 3,
    Prodotto = 4,
    ErroreProduzione = 5,
    NotificatoProdotto = 6,
    Spedito = 7
}


// WEBPACK FOOTER //
// ./src/app/_models/lotto-produzione.ts